export const selectLocale = (state) => state.configuration.search.locale;
export const selectTimezone = (state) => state.configuration.search.timezone;
export const selectAccessToken = (state) => state.configuration.accessToken;
export const selectOrganizationId = (state) => state.configuration.organizationId;
export const selectEnvironment = (state) => state.configuration.environment;
/**
 * Selects the agent ID from the knowledge configuration.
 * Used for agent-based answer generation via the Agent API.
 */
export const selectAgentId = (state) => state.configuration?.knowledge?.agentId;
export const selectDebugAgentSession = (state) => state.configuration.knowledge.debugAgentSession;
